import React from 'react'

import { classes } from '../utils'

type Props = {
  children: React.ReactElement | React.ReactNode | string | null
  /** Level: h1, h2, h3, h4 */
  level?: 1 | 2 | 3 | 4
  /** External classname */
  className?: string
  /**
   * If true, use Aeonik font instead of default font.
   */
  aeonik?: boolean
}

// TODO: refresh header styles
/** Heading element. */
const Heading = ({
  children,
  level,
  className,
  aeonik,
  ...rest
}: Props & React.BaseHTMLAttributes<never>) => {
  const defaultClasses = classes(
    'font-sans',
    {
      'font-aeonik': aeonik,
    },
    className,
  )

  if (level === 1) {
    return (
      <h1
        className={classes('text-3xl font-bold leading-tight', defaultClasses)}
        {...rest}
      >
        {children}
      </h1>
    )
  }

  if (level === 3) {
    return (
      <h3
        className={classes(
          'text-base font-medium uppercase tracking-widest sm:truncate',
          defaultClasses,
        )}
        {...rest}
      >
        {children}
      </h3>
    )
  }

  if (level === 4) {
    return (
      <h4
        className={classes('text-base font-medium sm:truncate', defaultClasses)}
        {...rest}
      >
        {children}
      </h4>
    )
  }

  return (
    <h2
      className={classes(
        'text-xl font-medium sm:truncate sm:text-2xl',
        defaultClasses,
      )}
      {...rest}
    >
      {children}
    </h2>
  )
}

Heading.defaultProps = {
  level: 2,
}

export default Heading
